import { getServiceUrl } from '../api.config';
import { ApiClientOptions } from '../types/api';
import ApiClient from '../utils/ApiClient';
import qs from '../utils/query';
import {
  isBoolean,
  isNotEmptyString,
  isPositiveInteger,
} from '../utils/validators';

export default class SourcingLabelApi extends ApiClient {
  public constructor(options?: ApiClientOptions) {
    super(getServiceUrl('core'), options);
  }

  public list({ queries = {}, offset, limit, useCache = true }: any = {}) {
    const query = '/core/v3/productsegments/sourcinglabel';
    const params: any = {};
    if (isNotEmptyString(queries.name)) {
      params.filter_name_like = queries.name;
    }
    if (isBoolean(queries.withSynchronized)) {
      params.with_synchronized = queries.withSynchronized;
    }
    if (isPositiveInteger(offset)) {
      params.offset = offset;
    }
    if (isPositiveInteger(limit)) {
      params.limit = limit;
    }
    return this.get(query, qs.stringify(params, true), useCache);
  }

  public upsert({ organizationId, userLabels }: any) {
    // userLabels : list of { name: x, [shortId: x]}
    const query = '/core/v3/productsegments/sourcinglabel/multiple';
    return this.put(query, {
      organization: {
        id: organizationId,
      },
      productsegments: userLabels,
    });
  }

  public attach({ productSegmentIds, productIds }: any) {
    const query = '/core/v3/productsegments/sourcinglabel/products/attach';
    return this.post(query, {
      product_ids: productIds,
      productsegment_ids: productSegmentIds,
    });
  }

  public detach({ productSegmentIds, productIds }: any) {
    const query = '/core/v3/productsegments/sourcinglabel/products/detach';
    return this.post(query, {
      product_ids: productIds,
      productsegment_ids: productSegmentIds,
    });
  }

  public share({ emails, productSegmentIds, message }: any) {
    const query = '/core/v3/productsegments/sourcinglabel/share';
    return this.post(query, {
      emails,
      message,
      productsegment_ids: productSegmentIds,
    });
  }

  public acceptShare({
    sourceProductSegmentId,
    sourceOrganizationId,
    label,
  }: any) {
    const query = '/core/v3/productsegments/sourcinglabel/share/accept';
    return this.post(query, {
      label,
      source_organization_id: sourceOrganizationId,
      source_productsegment_id: sourceProductSegmentId,
    });
  }

  public refuseShare({ sourceProductSegmentId, sourceOrganizationId }: any) {
    const query = '/core/v3/productsegments/sourcinglabel/share/refuse';
    return this.post(query, {
      source_organization_id: sourceOrganizationId,
      source_productsegment_id: sourceProductSegmentId,
    });
  }
}
